/* THIS FILE IS GENERATED. DO NOT EDIT */

import theme from 'base/components/standalone/Adunit/theme';

export const AdunitTheme = theme;
